/**
 * OAuth Client ID (tipo "Aplicación web") de Google Cloud. Es el MISMO valor que el
 * backend guarda en Authentication:Google:ClientId y usa como audiencia al validar el
 * ID token: si los dos no coinciden, el token que emite el navegador se rechaza en el
 * servidor con GOOGLE_INVALID_TOKEN.
 *
 * No es un secreto —viaja en el HTML de cualquier sitio que use Google Sign-In— pero sí
 * cambia por ambiente, y los orígenes autorizados se configuran en la consola de Google.
 *
 * Vacío = no se dibuja el botón de Google. Es el estado por defecto en desarrollo, y es
 * a propósito: un botón que siempre falla es peor que ningún botón.
 */
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export const isGoogleAuthEnabled = (): boolean => GOOGLE_CLIENT_ID !== '';
